<template>
  <div class="flex gap-2 items-center px-2 pt-2 pb-2 -mx-2 -mt-2 mb-2 bg-gray-800 rounded-t-lg border-b border-gray-700 border-opacity-75">
    <slot />
  </div>
</template>

<script setup></script>
